import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Router } from '@angular/router';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Company, CompanyList, CompanyPayload } from '../model/company.model';
import { SfAccount } from '../model/salesforce.model';

@Injectable()
export class CompanyService extends KiwixiService {
    apiCompany = environment.server + 'compagnies/';

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    /**
     * Récupère la liste des companies avec filtres (pagination, tri, recherche)
     */
    getCompagnies(params?: HttpParams): Observable<CompanyList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<CompanyList>(this.apiCompany, {
            headers: header,
            params: params
        }).
            pipe(
                catchError(this.handleErrorObservable<any>(`getCompagnies`))
            );
    }

    /**
     * Récupère la liste des companies avec objet params (compatible avec BusinessService)
     */
    get(params: any): Observable<CompanyList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<CompanyList>(this.apiCompany, {
            params: params,
            headers: header
        }).pipe(
            catchError(this.handleErrorObservable<CompanyList>('getCompaniesWithParams'))
        );
    }

    /**
     * Récupère une company par ID
     */
    getOne(id: number | string, salt = false): Observable<Company> {
        const header = this.createHttpClientAuthorizationHeader();
        let url = this.apiCompany + id + '/';
        if (salt) {
            url += '?salt=' + Math.random();
        }
        return this._http.get<Company>(url, {
            headers: header
        }).pipe(
            catchError(this.handleErrorObservable<Company>('getCompanyById'))
        );
    }

    getCompanyWithUrl(_url): Observable<Company> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<Company>(_url, {
            headers: header
        }).
            pipe(
                catchError(this.handleErrorObservable<any>(`getCompanyWithUrl`))
            );
    }

    /**
     * Crée une nouvelle company
     */
    postCompany(params): Observable<Company> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.post<Company>(this.apiCompany, params, {
            headers: header,
        }).
            pipe(
                catchError(this.handleErrorObservable<any>(`postCompany`))
            );
    }

    /**
     * Crée une company (alias pour compatibilité)
     */
    post(data: CompanyPayload | FormData): Observable<Company> {
        const header = this.createHttpClientAuthorizationHeaderNoEnctype();
        return this._http.post<Company>(this.apiCompany, data, { headers: header }).pipe(
            catchError(this.handleErrorObservable<Company>('postCompanyNew'))
        );
    }

    patchCompany(id, params): Observable<Company> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.patch<Company>(this.apiCompany + id + '/', params, {
            headers: header,
        }).
            pipe(  
                catchError(this.handleErrorObservable<any>(`patchCompany`))
            );
    }

    /**
     * Met à jour une company (alias pour compatibilité)
     */
    patch(data: Partial<CompanyPayload> | FormData, id: number | string): Observable<Company> {
        const header = this.createHttpClientAuthorizationHeaderNoEnctype();
        return this._http.patch<Company>(this.apiCompany + id + '/', data, { headers: header }).pipe(
            catchError(this.handleErrorObservable<Company>('patchCompanyNew'))
        );
    }

    /**
     * Supprime une company
     */
    delete(id: number | string): Observable<any> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.delete(this.apiCompany + id + '/', { headers: header }).pipe(
            catchError(this.handleErrorObservable<any>('deleteCompany'))
        );
    }

}


